import React from 'react'
import {AppBar} from '@material-ui/core';
import PropTypes from 'prop-types';
import StageElement from './components/StageElement';
import GridBlock from 'components/GridBlock';
import RouterPath from "libs/RouterPath";
import {makeStyles} from "@material-ui/styles";

const useStyle = makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        top: 64,
        zIndex: 1099
    },
    gridItem: {
        flexGrow: 1
    },
    modification: {
        fontWeight: 400
    }
}))

export const createStageBarElement = (label, path, current, historyPush = true, label2, onClick) => ({label, path, current, historyPush, label2, onClick})

function StageBarCommon(
    {
        location,
        elements
    }) {
    const classes = useStyle();

    const stageClick = ({onClick, path, historyPush}) => {
        if (onClick) {
            onClick();
        } else if (path) {
            if (historyPush)
                RouterPath.redirect(path);
            else
                RouterPath.redirectWithoutHistory(path);
        }
    }

    return (
        <AppBar
            id='stageBar'
            component='div'
            elevation={0}
            position='sticky'
            className={classes.root}
        >
            <GridBlock
                itemClassName={classes.gridItem}
            >
                {elements.map((element, i) => {
                    const {label, path, current, label2, onClick} = element;
                    return (
                        <StageElement
                            key={i}
                            current={current}
                            onClick={onClick || path ? () => stageClick(element) : undefined}
                        >
                            {label} {!!label2 && <span className={classes.modification}>({label2})</span>}
                        </StageElement>
                    )
                })}
            </GridBlock>
        </AppBar>
    )
}

StageBarCommon.propTypes = {
    elements: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        path: PropTypes.string,
        current: PropTypes.bool,
        historyPush: PropTypes.bool,
        label2: PropTypes.string,
        onClick: PropTypes.func
    }))
}

export default StageBarCommon;